import React from 'react';
import { observer } from 'mobx-react';
import {
  BoosterDtoTypeEnum, CampaignConfigDto, DiscountDto,
  PopulatedCampaignUserDtoStatusEnum,
} from '@coretava/api/ecommerce-service';
import { useTheme } from '@mui/material/styles';
import { WheelStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers/wheel';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import ReferralCampaign from './referral/ReferralCampaign';
import SurveyCampaign from './survey/SurveyCampaign';
import WheelCampagin from './wheel/WheelCampagin';
import BasicCampaign from './basic/BasicCampaign';

const CampaignContent: React.FC<{
   campaign: CampaignConfigDto,
    status: PopulatedCampaignUserDtoStatusEnum,
   discount?: DiscountDto,
   textAlign?: 'center' | 'left'
  }> = ({
    campaign,
    status,
    discount,
    textAlign,
  }) => {
    const theme = useTheme();

    return React.useMemo(() => {
      switch (campaign.booster?.type) {
        case BoosterDtoTypeEnum.Basic:
          return <BasicCampaign campaign={campaign} discount={discount} textAlign={textAlign} />;
        case BoosterDtoTypeEnum.Referal:
          return <ReferralCampaign campaign={campaign} status={status} discount={discount} refereeDiscount={CampaignUserStore.refereeCampaignDiscount} />;
        case BoosterDtoTypeEnum.Survey:
          return <SurveyCampaign campaign={campaign} discount={discount} status={status} />;
        case BoosterDtoTypeEnum.Wheel:
          return WheelStore.wheel && <WheelCampagin status={status} wheel={WheelStore.wheel} discount={discount} />;
        default:
          return undefined;
      }
    }, [campaign, theme, discount, WheelStore.wheel, CampaignUserStore.refereeCampaignDiscount]);
  };

export default observer(CampaignContent);
